import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDeleteAttribute = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [deleteLoading, setDeleteLoading] = useState(false);

  const deleteRequest = ({ guid, alternativeGuid, onSuccess }) => {
    setDeleteLoading(true);

    axiosClient
      .delete(
        `SettingProduct/CoddingAttribute/Delete?GUID=${guid}&AlternativeGuid=${alternativeGuid}`,
      )
      .then(res => {
        if (res.status === 200) {
          onSuccess?.();
          enqueueSnackbar(`حذف با موفقیت انجام شد`, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setDeleteLoading(false));
  };
  return { deleteRequest, deleteLoading };
};

export default useDeleteAttribute;
